import shopDetailsSymbols from "../symbols/shopDetails";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function shopDetails(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case shopDetailsSymbols.SHOP_DETAILS:
      return { ...state, loading: true, error: false };
    case shopDetailsSymbols.SHOP_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case shopDetailsSymbols.SHOP_DETAILS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case shopDetailsSymbols.CLEAR_SHOP_DETAILS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
